export const COVER_TYPE_COLOR = 'color';
export const COVER_TYPE_IMAGE = 'image';
// export const COVER_TYPE_NONE = 'none';



// WEBPACK FOOTER //
// ./app/constants/cover-types.js